<template>
  <H5Layout title="语音识别录音" active="meeting">
    <AMeeting></AMeeting>
  </H5Layout>
</template>

<script>
import H5Layout from "./H5Layout.vue";
import AMeeting from "@/vue_views/AMeeting.vue";

export default {
  name: "MeetingH5",
  components: {
    H5Layout,
    AMeeting
  }
}
</script>

<style>
/* AMeeting 内部移动端微调（复用 H5Layout 全局覆盖之外的细节） */
.h5-layout .Meeting-container .task-bar {
  padding: 8px;
}

.h5-layout .Meeting-container .task-list {
  flex-wrap: nowrap;
}
</style>
